import React from "react";

import { Grid, Typography } from "@material-ui/core";

import LightPurpleContainer from "../../../../components/LightPurpleContainer";
import logo from "../../../../assets/images/logo.svg";
import { routes } from "../../../../api/paths";

export default function Footer() {
  return (
    <LightPurpleContainer>
      <Grid container alignItems="center">
        <Grid item md={2} xs={12}>
          <a href={routes.RODILISTA_RODA_HR} target="_blank">
            <img src={logo} alt="logo" style={{ width: "10rem" }} />
          </a>
        </Grid>
        <Grid item md={9} xs={12} alignItems="flex-start">
          <Typography>
            U slučaju bilo kakvih pitanja ili tehničkih poteškoća, javite nam se
            putem e-pošte na adresu rodilista@roda.hr.
          </Typography>
        </Grid>
      </Grid>
    </LightPurpleContainer>
  );
}
